import store from './store'

export default {
  store,
  install (Vue, options) {
    Vue.prototype.$store = store
  }
}


// WEBPACK FOOTER //
// ./src/storePlugin.js